exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#taskReport .task-li[data-v-0d816b14]{height:40px;line-height:40px;font-size:14px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}#taskReport .active[data-v-0d816b14]{color:#1890fa;font-weight:700}#taskReport[data-v-0d816b14] .el-collapse-item__content{padding-bottom:25px}", ""]);

// exports
